module.exports = __webpack_public_path__ + "media/images/amenities_icons/free_tea-9859a9f1d48f264ed0b50510e3b16ab9.svg";